// CategoryFilter.js - Category toggle buttons

import React from 'react';
import { CATEGORIES } from '../data/events';

export function CategoryFilter({ activeCategories, onToggle }) {
  return (
    <div className="category-filter">
      {Object.entries(CATEGORIES).map(([key, cat]) => {
        const isActive = activeCategories.includes(key);
        return (
          <button
            key={key}
            className={`cat-btn ${isActive ? 'active' : ''}`}
            style={{
              '--cat-color': cat.color,
              borderColor: isActive ? cat.color : 'transparent',
              background: isActive ? `${cat.color}22` : 'rgba(0,0,0,0.4)',
            }}
            onClick={() => onToggle(key)}
            title={cat.label}
          >
            <span className="cat-btn-icon">{cat.icon}</span>
            <span className="cat-btn-label">{cat.label}</span>
          </button>
        );
      })}
    </div>
  );
}
